var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 75,
    viewBox: "0 0 78 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1288 60.8134L62.9701 60.8191L69.3745 68.7411L8.6333 68.7846L15.0448 60.8527L7.87827 60.8593L0.649384 69.8004C0.31192 70.2176 0.0952351 70.7276 0.0249407 71.2701C-0.0453536 71.8126 0.0336807 72.3648 0.252703 72.8616C0.471725 73.3584 0.821578 73.779 1.26091 74.0736C1.70025 74.3682 2.2107 74.5245 2.73194 74.5241L75.2704 74.4717C75.7914 74.4714 76.3014 74.3147 76.7403 74.0198C77.1792 73.725 77.5285 73.3044 77.7472 72.8077C77.9658 72.311 78.0446 71.759 77.9742 71.2169C77.9038 70.6747 77.6871 70.165 77.3498 69.748L70.1288 60.8134ZM32.2449 0.792969V17.7552H19.2169L38.9996 38.6203L58.7823 17.7552H45.7543V0.792969H32.2449ZM56.3558 27.2739C54.5486 29.1811 52.7429 31.0899 50.9341 32.9963H54.8341L69.3729 50.9842L39.0031 51.0055L8.6333 51.0268L23.2081 32.9955H27.0659C25.2586 31.0883 23.4491 29.186 21.6411 27.2788C20.9494 27.3599 20.3132 27.7153 19.8627 28.2726L0.650164 52.0435C0.312941 52.4607 0.0964634 52.9707 0.0263022 53.513C-0.0438589 54.0553 0.0352283 54.6074 0.254221 55.1041C0.473214 55.6007 0.822963 56.0211 1.26215 56.3157C1.70134 56.6103 2.21163 56.7666 2.73272 56.7664L75.2712 56.7139C75.7922 56.7137 76.3022 56.5569 76.7411 56.2621C77.1799 55.9672 77.5293 55.5466 77.7479 55.05C77.9666 54.5533 78.0454 54.0013 77.975 53.4591C77.9045 52.9169 77.6879 52.4073 77.3506 51.9902L58.1794 28.2726C57.7187 27.7027 57.0644 27.3444 56.3558 27.2739Z",
    fill: "url(#paint0_linear_7694_6344)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7694_6344",
    x1: 39,
    y1: 0.792969,
    x2: 39,
    y2: 74.5241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E57E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D150E3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.cd66f865362575ef960ca0fe29972518.svg";
export { ForwardRef as ReactComponent };